module.exports = __webpack_public_path__ + "static/media/sistema-dashboard-plano-starter.1f066446.png";